import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CuttingLayout } from './CuttingLayout';
import { CuttingTabBar } from './CuttingTabBar';
import { useCuttingStore } from './state/useCuttingStore';
import { ImportFormatDialog } from './dialogs/ImportFormatDialog';

/**
 * Block 14 «Раскрой» — Экран 2.14.1 «Начало» (`start.html`). PR #2-UI + #4-SHELL.
 *
 * Видеокнопка → subtitle → 3 карточки (вертикаль, P-019). Живые действия (прототип
 * start.html): «Ввести вручную» → новый пустой проект в сторе → `/cutting/project`;
 * «Импортировать файл» → модалка формата `ImportFormatDialog`; «Открыть старый
 * проект» → `/cutting/history`. Текст карточки импорта — канон §IX.Z.
 */

interface StartCard {
  id: string;
  icon: string;
  title: string;
  desc: string;
}

const CARDS: StartCard[] = [
  {
    id: 'manual',
    icon: '✏️',
    title: 'Ввести вручную',
    desc: 'Заполните таблицу деталей, настройки и параметры раскроя сами. Подходит для небольших проектов и новых задач.',
  },
  {
    id: 'import',
    icon: '📥',
    title: 'Импортировать файл',
    desc: 'Загрузите готовый список из Excel, Pro100, Базис, BCAD, ГибЛаб.',
  },
  {
    id: 'history',
    icon: '📂',
    title: 'Открыть старый проект',
    desc: 'История ваших проектов раскроя с поиском, фильтрами и сортировкой.',
  },
];

export function CuttingStart() {
  const navigate = useNavigate();
  const newProject = useCuttingStore((s) => s.newProject);
  const [importOpen, setImportOpen] = useState(false);

  const onCard = (id: string) => {
    if (id === 'manual') {
      newProject(); // новый пустой проект в сторе
      navigate('/cutting/project');
    } else if (id === 'import') {
      setImportOpen(true);
    } else {
      navigate('/cutting/history');
    }
  };

  return (
    <CuttingLayout title="Раскрой" tabBar={<CuttingTabBar />}>
      <div className="sc-start-wrapper">
        {/* Видеоинструкция — стиль прототипа (видео-URL подключается в след. PR) */}
        <button type="button" className="sc-menu-item video-card" aria-label="Видеоинструкция">
          <div className="sc-menu-icon video-play">▶</div>
          <div className="sc-menu-text">Видеоинструкция</div>
          <div className="sc-menu-arrow">›</div>
        </button>

        <div className="sc-start-subtitle">Выберите способ создания проекта раскроя</div>

        <div className="sc-start-cards">
          {CARDS.map((card) => (
            <button
              key={card.id}
              type="button"
              className="sc-start-card"
              onClick={() => onCard(card.id)}
            >
              <div className="card-icon">{card.icon}</div>
              <div>
                <div className="card-title">{card.title}</div>
                <div className="card-desc">{card.desc}</div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {importOpen && <ImportFormatDialog onClose={() => setImportOpen(false)} />}
    </CuttingLayout>
  );
}
